"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sumTransactions = exports.getEnvelope = exports.getNonVariableEnvelopes = exports.precision = void 0;
const lodash_1 = __importDefault(require("lodash"));
const enums_1 = require("./types/enums");
function precision(number, precision = 2) {
    return Number(number.toFixed(precision));
}
exports.precision = precision;
function getNonVariableEnvelopes(budget) {
    return lodash_1.default.reject(budget.envelopes, e => e.type === enums_1.EnvelopeType.Variable || e.type === enums_1.EnvelopeType.VariableIncome);
}
exports.getNonVariableEnvelopes = getNonVariableEnvelopes;
function getEnvelope(budget, envelopeName) {
    return lodash_1.default.find(budget.envelopes, e => e.type === envelopeName);
}
exports.getEnvelope = getEnvelope;
function sumTransactions(transactions) {
    return lodash_1.default.sumBy(transactions, t => (t.billingAmount || 0) - (t.incomeAmount || 0)) || 0;
}
exports.sumTransactions = sumTransactions;
//# sourceMappingURL=utils.js.map